import gsap from 'gsap';
import EmitEvent, {
    BEFORE_LOADING,
    PAGE_ENTER,
    PAGE_LOADED,
    PAGE_ONE
} from "../../../libs/emit-event";
import {checkDeviceMobile} from "../../../libs/helper";

export class PageLoading {
    constructor() {
        this.DOM = {main: document.querySelector('.js-pageLoading')};
        document.body.classList.add('js-ready');
        EmitEvent.emit(BEFORE_LOADING);
        this.bindEvent();
    }

    loaded() {
        EmitEvent.emit(PAGE_LOADED);
        document.body.classList.add('is-loaded');
        gsap.to(this.DOM.main, {
            opacity: 0, ease: "power3.inOut", duration: .6, onComplete: () => {
                EmitEvent.emit(PAGE_ENTER);
                EmitEvent.emit(PAGE_ONE);
                this.DOM.main.remove();

            }
        });

        if (checkDeviceMobile()) {
            document.body.style.overflow = null;
        }
    }

    bindEvent() {
        window.addEventListener('load', this.loaded.bind(this));
    }
}